module.exports = __webpack_public_path__ + "img/lipigo_5.7428e837.png";